import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Image from "../../../assets/images/image/postcard.png";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import { appear } from "../../animations/Appear";
import UnderlineButton from "../../buttons/UnderlineButton";

const Wrapper = styled.div`
  height: fit-content;
  width: 100%;
  border: 1px solid #7372722f;
  background-color: #f8f6f661;
  animation: ${({ inView }) => (inView ? appear : "none")} 2s forwards;
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;

  @media (max-width: 950px) {
    flex-direction: column;
    gap: 24px;
    padding-top: 100px;
    justify-content: center;
  }
`;

const Left = styled.div`
  flex: 1;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.2rem;
  box-sizing: border-box;
  max-width: 500px;
  margin: 0 auto;

  span {
    letter-spacing: 0.14rem;
    color: ${colors.maroon};
    font-size: ${fontSize.s};
    font-weight: 200;
    text-transform: uppercase;
  }

  p {
    letter-spacing: 0.09rem;
    word-spacing: 0.1rem;
    line-height: 1.6;
    color: ${colors.primaryGray};
    font-size: ${fontSize.xxs};
  }

  @media (max-width: 950px) {
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: 90vw;
  }
`;

const Right = styled.div`
  width: 50%;
  max-width: 50vw;
  max-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 950px) {
    /* width: 100%;*/
    max-width: 100%;
    width: 85vw;
    height: auto;
    margin-bottom: 8vw;
  }
`;

const Space = styled.div`
  height: 35px;

  @media (max-width: 950px) {
    height: 20px;
  }
`;

function HandwovenSection() {
  const { ref, inView } = useInView({
    triggerOnce: false,
  });
  const navigate = useNavigate();
  return (
    <Wrapper ref={ref} inView={inView}>
      <Container>
        <Left>
          <span>Heritage Himalayan Pashmina & Wool</span>
          <Space />
          <p>
            Founded with the hope of preserving the slowly disappearing art of
            hand-harvested, hand-woven pashmina and wool, Made in the Himalayas
            is deeply rooted in Himalayan heritage.
          </p>
          <Space />
          <p>
            Our products are handcrafted by local artisans using skills passed
            down through generations, working with fibers sourced from animals
            that live freely in their natural surroundings.
          </p>
          <Space />
          <p>
            We believe in sustaining tradition through ethical practices where
            animals, artisans, and nature coexist in mutual respect
          </p>
          <Space />
          <div>
            <UnderlineButton
              placeholder={"DISCOVER MORE"}
              color={colors.maroon}
              onClick={() => navigate("/founder")}
            />
          </div>
        </Left>
        <Right ref={ref} inView={inView}>
          <img src={Image} alt="" />
        </Right>
      </Container>
    </Wrapper>
  );
}

export default HandwovenSection;
